module.exports = __webpack_public_path__ + "img/21 Animation 2-squashed.879933b1.jpg";